import React from 'react';
import { Link } from 'react-router-dom';
import { Card, Alert, Button } from 'react-bootstrap';
import { FiEye } from 'react-icons/fi';
import { useTranslation } from '../../../hooks/useTranslation';
import { useDashboardFilters } from './hooks/useDashboardFilters';
import { useObservationDashboard } from './hooks/useDashboardData';
import DashboardPageHeader from './components/DashboardPageHeader';
import OperationsNav from './components/OperationsNav';
import DashboardFilters from './components/DashboardFilters';
import ObservationTable from './components/ObservationTable';
import 'bootstrap/dist/css/bootstrap.css';
import './operations-dashboard.css';

const ObservationDashboard = () => {
    const { t } = useTranslation();
    const { filters, setFilter, resetFilters, hasActiveFilters } = useDashboardFilters();
    const { data, loading, error, refetch, isError } = useObservationDashboard(filters);

    const claimsItems = data?.claims?.items || null;
    const fntItems = data?.forecast_not_triggered?.items || null;

    if (isError && !data) {
        return (
            <div className="dashboard-page">
                <Alert variant="danger">
                    <Alert.Heading>Erreur de chargement</Alert.Heading>
                    <p className="mb-3">{error}</p>
                    <Button variant="outline-danger" size="sm" onClick={refetch}>
                        Réessayer
                    </Button>
                </Alert>
            </div>
        );
    }

    return (
        <div className="dashboard-page">
            <Card className="admin-ds-main-card">
                <Card.Body>
                    <DashboardPageHeader
                        title={t('pages.operationsDashboard.observationTitle')}
                        icon={FiEye}
                        referenceDate={data?.reference_date}
                        metadata={data?.metadata}
                        onRefresh={refetch}
                        refreshing={loading}
                        breadcrumb={[
                            { label: 'Opérations', to: '/dashboard/operations' },
                            { label: 'Observation' },
                        ]}
                    />

                    <OperationsNav />

                    <DashboardFilters
                        filters={filters}
                        onFilterChange={setFilter}
                        onReset={resetFilters}
                        hasActiveFilters={hasActiveFilters}
                        visibleFilters={[
                            'run_date',
                            'policy_code',
                            'partner_id',
                            'company_name',
                            'distribution_type',
                            'include_completed',
                            'scope',
                            'observation_timing_hour',
                        ]}
                    />

                    <Card className="admin-ds-section-card">
                        <Card.Body className="p-0">
                            <ObservationTable
                                claims={claimsItems}
                                forecastNotTriggered={fntItems}
                                loading={loading && !data}
                                scope={filters.scope}
                            />
                        </Card.Body>
                    </Card>

                    <div className="mt-3">
                        <Button variant="link" as={Link} to="/dashboard/operations" className="p-0">
                            ← Retour au tableau de bord
                        </Button>
                    </div>
                </Card.Body>
            </Card>
        </div>
    );
};

export default ObservationDashboard;
